import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import "./createAd.scss";
import { handleImageUpload, uploadVideo } from "../../assets/firebaseStorage";
import { createAdvertisementFB, editAdvertisement, getOneAd } from "../../assets/firebaseFirestore";
import CreateAdForm from "./createAdForm";
import Loader from "../Loader/Loader";

const INITIAL_VALUES = {
  title: "",
  description: "",
  link: "",
  country: "",
  active: true,
  mediaType: "image",
};

const Index = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [defaultAd, setDefaultAd] = useState(null);
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [video, setVideo] = useState(null);
  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState(INITIAL_VALUES);

  useEffect(() => {
    if (id) {
      getOneAd(id).then((res) => {
        setValues(res);
        setDefaultAd(res);
      });
    }
  }, [id]);

  const changeValue = (val, key) => {
    setValues((prev) => ({ ...prev, [key]: val }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      let payload = { ...values, ...(id && { id }) };

      if (values.mediaType === "video") {
        const videoRes = await uploadVideo(video, values?.video?.id);
        payload.video = videoRes ? { ...videoRes } : { ...values?.video };
      } else {
        const [res1, res2] = await Promise.all([
          handleImageUpload(image, values?.image?.id),
          handleImageUpload(image2, values?.desktop_image?.id),
        ]);
        payload.image = res1 ? { ...res1 } : { ...values?.image };
        payload.desktop_image = res2 ? { ...res2 } : { ...values?.desktop_image };
      }

      if (id) {
        await editAdvertisement(payload, navigate);
      } else {
        await createAdvertisementFB(payload, navigate);
      }
    } catch (error) {
      console.error("Error submitting advertisement:", error);
    } finally {
      setLoader(false);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loader && <Loader />}
      <Card>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <Link to={"/"}>
            <MDButton variant="gradient" color="primary">
              <Icon sx={{ fontWeight: "bold" }}>arrow_back</Icon>
              &nbsp;Back
            </MDButton>
          </Link>
        </MDBox>

        <CreateAdForm
          values={values}
          changeValue={changeValue}
          onSubmit={onSubmit}
          defaultAd={defaultAd}
          image={image}
          setImage={setImage}
          image2={image2}
          setImage2={setImage2}
          video={video}
          setVideo={setVideo}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Index;
